import { useMutation } from "@tanstack/react-query";

import { axiosInstance } from "../../axios";

const deleteDocument = async (id: string) => {
  return await axiosInstance
    .delete(`documents/${id}`)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

function useDeleteDocument() {
  return useMutation({
    mutationFn: (id: string) => deleteDocument(id),
    mutationKey: ["documentsList"],
  });
}

export default useDeleteDocument;
